import { client } from '@trello/graphql';

import { WorkspaceState } from '../workspaceState';

import {
  WorkspaceForOrganizationDocument,
  WorkspaceForOrganizationQueryResult,
  WorkspaceForOrganizationQueryVariables,
} from './WorkspaceForOrganization.generated';

export async function getWorkspaceStateForOrganization(
  name: string,
): Promise<WorkspaceState> {
  const results = await client.query<
    WorkspaceForOrganizationQueryResult['data'],
    WorkspaceForOrganizationQueryVariables
  >({
    query: WorkspaceForOrganizationDocument,
    variables: { name },
  });
  return {
    status: 'READY',
    error: null,
    isGlobal: false,
    idWorkspace: results?.data?.organization?.id ?? null,
  };
}
